// extracted by mini-css-extract-plugin
export var audioPlayer = "_rs-0";